(ns hypnos.backoffice.app
  "The BackOffice application."
  (:require ["aws-amplify-react" :refer (ConfirmSignIn
                                         ;; ConfirmSignUp
                                         ForgotPassword
                                         RequireNewPassword
                                         SignIn
                                         ;; SignUp
                                         VerifyContact
                                         withAuthenticator)]
            [hypnos.backoffice.bar.aside :as aside]
            [hypnos.backoffice.bar.footer :as footer]
            [hypnos.backoffice.bar.navigation :as nav]
            [hypnos.backoffice.bar.title :as title]
            [hypnos.backoffice.panel.dashboard :as dashboard]
            [hypnos.backoffice.panel.error :as error]
            [hypnos.backoffice.panel.patient :as patient]
            [hypnos.backoffice.panel.patients :as patients]
            [hypnos.graphql.queries :as queries]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- panels
  [panel]
  (case (:name panel)
    ;; external
    :dashboard-panel [dashboard/panel]
    :patient-panel   [patient/panel (:params panel)]
    :patients-panel  [patients/panel]
    [:div]))

(defn- container
  []
  (let [_ (rf/dispatch-sync [:amplify/get-auth-session :backoffice/set-session :backoffice/set-error])
        _ (rf/dispatch-sync [:amplify/query queries/get-user {} :backoffice/set-user :backoffice/set-error])
        _ (rf/dispatch [:amplify/query queries/get-catalog {} :backoffice/set-catalog :backoffice/set-error])]
    (fn []
      (let [active-panel (rf/subscribe [:backoffice/active-panel])]
        [:div
         [nav/bar]
         [aside/primary]
         [aside/secondary]
         [title/bar]
         [error/panel]
         [panels @active-panel]
         [footer/bar]]))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; API

(def app
  (reagent/adapt-react-class
   (withAuthenticator
    (reagent/reactify-component container)
    false
    #js [(reagent/create-element SignIn)
         (reagent/create-element ConfirmSignIn)
         (reagent/create-element VerifyContact)
         (reagent/create-element RequireNewPassword)
         (reagent/create-element ForgotPassword)])))
